import React from "react";
import { AuditLog } from "@common/types/auditLog";
import { AuditLogActor } from "../AuditLogActor";

interface Props {
    log: AuditLog;
}

export const TransactionLogCategoryContent: React.FC<Props> = ({ log }) => {
    const newCategoryLabel =
        log.diff.find((d) => d.field === "categoryId")?.after?.valueLabel ?? "";
    const authorComponent = (
        <AuditLogActor
            actorId={log.actorId}
            actorName={log.actorName}
            actorType={log.actorType}
            log={log}
        />
    );

    return (
        <>
            <strong>{authorComponent}</strong> changed the category to{" "}
            <strong>{newCategoryLabel}</strong>.
        </>
    );
};
